export default __webpack_public_path__ + "static/media/ct5.1.fbee33f6.png";